/**
 * Vanilla store for recorder UI state (LOGGER chip + trip instrument). High
 * frequency, so it lives outside React like posStore; components subscribe with
 * narrow selectors.
 */
import { createStore } from 'zustand/vanilla';

export interface RecorderUiState {
  isRecording: boolean;
  tripDistanceNm: number;
  /** epoch ms of the last mid-trip fix gap — UI re-surfaces the setup guide. */
  lastGapAt: number | null;
  /** one-shot message after an auto-finalized leftover trip. */
  autoEndedMessage: string | null;
  setRecording: (isRecording: boolean) => void;
  setTripDistance: (nm: number) => void;
  setGap: (at: number) => void;
  setAutoEnded: (msg: string | null) => void;
}

export const recorderStore = createStore<RecorderUiState>((set) => ({
  isRecording: false,
  tripDistanceNm: 0,
  lastGapAt: null,
  autoEndedMessage: null,
  setRecording: (isRecording) => set({ isRecording }),
  setTripDistance: (tripDistanceNm) => set({ tripDistanceNm }),
  setGap: (lastGapAt) => set({ lastGapAt }),
  setAutoEnded: (autoEndedMessage) => set({ autoEndedMessage }),
}));
